export default __webpack_public_path__ + "static/media/longchamp32.46469f89.jpg";